import React from "react";
import { Outlet } from "react-router-dom";
import HeaderComponent from "../components/Header/HeaderComponent";
import BoxComponent from "../components/Box/BoxComponent";
import EmpresaProvider from "../provider/empresa/EmpresaProvider";

const CardapioLayout = () => {
    return <EmpresaProvider>
        <BoxComponent
            sx={{
                display: "flex",
                flexDirection: "column-reverse",
                // flexDirection: {
                //     xs: "column-reverse",
                //     sm: "column",
                // },
                // overflow: {
                //     xs: "hidden",
                //     sm: "auto"
                // },
                height: "100dvh",
                gap: 2
            }}
            component="div"
        >
            <BoxComponent
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    backgroundColor: "#FFF",
                    height: {
                        xs: "calc(100dvh - 94vh)",
                        sm: "auto"
                    }
                }}
                component="header">
                <HeaderComponent />
            </BoxComponent>

            <BoxComponent sx={{
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                height: "calc(100dvh)"
                // height: {
                //     xs: "height: calc(100dvh)",
                //     sm: "auto",
                // }
                // background: "#f5f5f5",
                // minHeight: "100vh",
                // gap: 1,
                // display: 'flex',
                // flexDirection: "column"
            }} component="main">
                <Outlet />
            </BoxComponent>
        </BoxComponent>
    </EmpresaProvider>
}

export default CardapioLayout;